import { render } from "./toast.vue?vue&type=template&id=42b8a696"
const script = {}

import "./toast.vue?vue&type=style&index=0&id=42b8a696&lang=less"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__